import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserService {
  userName = signal('');
  userEmail = signal('');
  userRole = signal('');
  userSubscription = signal('');

  /**
   * Call this after login or when user info updates.
   */
  setUser(user: {
    name: string;
    email: string;
    role: string;
    subscription: string;
  }): void {
    this.userName.set(user.name);
    this.userEmail.set(user.email);
    this.userRole.set(user.role);
    this.userSubscription.set(user.subscription);
  }

  /**
   * Call this on logout to clear all data.
   */
  clearUser(): void {
    this.userName.set('');
    this.userEmail.set('');
    this.userRole.set('');
    this.userSubscription.set('');
  }
}
